import { configureStore } from '@reduxjs/toolkit';
// import cartReducer from './cartSlice';
import userReducer from './userSlice';

import storage from 'redux-persist/lib/storage';
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist';

const rootReducer = combineReducers({
    user: userReducer,
})


const persistConfig = {
    key: 'root',
    storage,
}


const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
    reducer: persistedReducer
});

export default store;